import React from 'react'
import onClickOutside from 'react-onclickoutside'
import BuildOption, {
  BuildOptionProps
} from '@components/ui/FitOption/BuildOption'

export type BuildOptionWithHelperProps = BuildOptionProps & {
  type: string
  handleClickOutside: () => void
  outsideClickIgnoreClass: string
}

function BuildOptionWithHelper({
  optionValue,
  onSelect,
  selected = false,
  active,
  classes = ''
}: BuildOptionWithHelperProps) {
  return (
    <BuildOption
      variant="vertical"
      optionValue={optionValue}
      classes={classes}
      selected={selected}
      active={active}
      onSelect={onSelect}
    />
  )
}

export default onClickOutside(BuildOptionWithHelper)
